import {Divider, Grid, Stack} from "@mui/material";
import {KtaComponentRow} from "../types";
import SalaryIncreaseConfigToggle from "./SalaryIncreaseConfigToggle";

type Props = {
    rows: KtaComponentRow[];
    title: string;
    rowKey: string;
    handleExpands: (salaryComponent: string) => void;
    expands: Record<string, boolean>;
};

const KtaIncreaseConfigRows = ({rows, title, rowKey, handleExpands, expands}: Props) => {

    return (
        <Grid item xs={12} mt={1}>
            <Stack pl={1}>
                {rows.map((row, index, array) => (
                    <SalaryIncreaseConfigToggle
                        key={row.date}
                        index={index}
                        title={title + row.date}
                        handleOpen={handleExpands}
                        open={expands[rowKey + row.date]}
                        salaryComponent={rowKey + row.date}
                        margin={index === array.length - 1}
                        ktaMode={true}
                        ktaBase={rowKey}
                    />
                ))}
            </Stack>
            <Divider/>
        </Grid>
    );
};

export default KtaIncreaseConfigRows;
